// import { Component } from "react";
import LoginPage from "./components/LoginPage";
import HeadReferee from "./components/HeadReferee";
import SabbatReferee from "./components/SabbatReferee";
import SideRefereeNew from "./components/SideRefereeNew";
import SaloonMonitor from "./components/SaloonMonitor";
import { Route, Switch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route
          path="/HeadReferee"
          render={(props) => <HeadReferee {...props} />}
        />
        <Route
          path="/SabbatReferee"
          render={(props) => <SabbatReferee {...props} />}
        />
        <Route
          path="/SideRefereeNew"
          render={(props) => <SideRefereeNew {...props} />}
        />
        <Route
          path="/SaloonMonitor"
          render={(props) => <SaloonMonitor {...props} />}
        />
        <Route path="/" component={LoginPage} />
      </Switch>
    </QueryClientProvider>
  );
}
